<template>
  <div>
    <div class="kt-login-v2__title">
      <h3>Google Authenticator installeren</h3>
    </div>

    <div class="kt-login-v2__form kt-form pt-3">
      <div style="max-width: 500px; margin: 0 auto;">
        <p>
          Installeer Google Authenticator op je telefoon.
        </p>

        <div class="d-flex platforms">
          <div class="d-flex platform-container">
            <div class="px-2">
              <img
                src="/assets/images/android-logo.png"
                alt="Android logo"
                loading="lazy"
                decoding="async"
              >
            </div>

            <div class="pt-2 pr-4">
              <span style="font-size: 90%;">Voor Android</span>

              <div>
                <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=nl-NL">
                  <b>Google Authenticator downloaden</b>
                </a>
              </div>

              <button
                class="btn btn-secondary text-nowrap mt-3"
                @click="openDownloadPopup('android')"
              >
                App downloaden
              </button>
            </div>
          </div>

          <div class="d-flex platform-container">
            <div class="pr-2">
              <img
                src="/assets/images/apple-logo.png"
                alt="Apple logo"
                loading="lazy"
                decoding="async"
              >
            </div>

            <div class="pt-2">
              <span style="font-size: 90%;">Voor iOS</span>

              <div>
                <a href="https://apps.apple.com/nl/app/google-authenticator/id388497605">
                  <b>Google Authenticator downloaden</b>
                </a>
              </div>

              <button
                class="btn btn-secondary text-nowrap mt-3"
                @click="openDownloadPopup('ios')"
              >
                App downloaden
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="kt-login-v2__actions mt-4 justify-content-end">
        <button
          class="btn btn--primary"
          @click="page = AuthPage.TWO_FACTOR_AUTH_SETUP;"
        >
          <span>Ik heb de app geïnstalleerd</span>
          <i class="fas fa-chevron-right pl-2"/>
        </button>
      </div>
    </div>

    <confirmation ref="confirm"/>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { AuthPage, useAuthStore } from '@/stores/auth'
import Confirmation from '@/components/Confirmation.vue'
import { ref } from 'vue'
import type { ConfirmationType } from '@/misc/custom-types'

const authStore = useAuthStore()

const { page } = storeToRefs(authStore)

const confirm = ref<ConfirmationType>()

const openDownloadPopup = async (platform: 'android' | 'ios') => {
  const url = platform === 'android'
    ? 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=nl-NL'
    : 'https://apps.apple.com/nl/app/google-authenticator/id388497605'

  await confirm.value?.open({
    message: `
      <div>
        <img src="/assets/images/google-authenticator-qr-code.png" class="google-auth-img" alt="Google Authenticator QR-code">
        <p>
          Scan de QR-code met je telefoon of klik <a href="${url}" target="_blank">hier</a>
        </p>
      </div>
    `,
    showSubmit: true,
    showCancel: false,
    showSwalType: false,
    submitText: 'Sluiten',
    popupStyle: {
      'width': '29em !important'
    }
  })
}
</script>

<style scoped lang="scss">
.platforms {
  padding: 0.5rem;
  column-gap: 1rem;
}

.platform-container {
  max-width: 260px;
  padding-bottom: 1rem;
}

.platform-container:not(:last-of-type) {
  border-right: 1px solid lightgray;
}

img {
  width: 60px;
  height: auto;
  padding: 0.5rem;
}

a, a:hover {
  color: #00606f;
}

::v-deep(.google-auth-img) {
  width: 200px;
  height: 200px;
}
</style>
